import UsePercentageProfile from 'hooks/use-percentage-profle'
import useRouter from 'hooks/use-router'
import { useEffect } from 'react'
import { usePhotographer } from 'views/photographer/context'

function useGuard() {

  const { pathname, history, search } = useRouter()
  const protectedRoutes = []  //  [ '/photographer/upload', '/photographer/start?isYou=true']
  const [, { setError }] = usePhotographer()
  const { percentageProfile } = UsePercentageProfile()

  useEffect(() => {
    if (protectedRoutes.includes(pathname + search) && percentageProfile < 100 && percentageProfile !== 0) {
      setError(900)
      history.push('/photographer/error')
    }
  }, [pathname, search, percentageProfile])

}

export default useGuard